
import * as React from 'react';
import '../../../App.css';

import BoxDropper from './BoxDropper/BoxDropper';
import BoxGameState from './BoxGameState/BoxGameState';
import BoxLevel from './BoxLevel/BoxLevel';
import {BoxUI} from './BoxUI/BoxUI';

import ConsoleState from '../../../components/Console/ConsoleState';
import Loop from '../../../components/loop/Loop'
import MediaLayer from '../../../components/MediaLayer/MediaLayer'
import World from '../../../components/World/World'

class BoxGame extends React.Component {

    public render() {

        return (
            <Loop>
                <MediaLayer width={1024} height={576}>
                    <World>
                        <ConsoleState>
                            <BoxGameState>
                                <BoxLevel />
                                <BoxDropper />
                                <BoxUI />
                            </BoxGameState>
                        </ConsoleState>
                    </World>
                </MediaLayer>
            </Loop>
        );
    }
}

export default BoxGame;


// WEBPACK FOOTER //
// ./src/games/box-game/components/BoxGame.tsx